import { createContext } from 'react';
import { RouteName } from '../constants/route_name';

interface RouteKeyContextProps {
    routerKey: RouteName;
}

export const RouteKeyContext = createContext({} as RouteKeyContextProps);
